import { isRevolvingCreditProduct } from './productTypeHelpers';
const isDCHDelinquent = (billing, productType, featureFlags) => {
    return ((billing === null || billing === void 0 ? void 0 : billing.pastDue) &&
        featureFlags.isDigitalCollectionsEnabled &&
        isRevolvingCreditProduct(productType));
};
export default isDCHDelinquent;
